
import {
  CreateInventoryLogRequest,
  FilterInventoryLogRequest,
  InventoryLogModel,
} from "../../../infrastructure/model/InventoryOnHandModel";
import InventoryLogService from "../../../infrastructure/services/InventoryLogService";
import { PageResponse } from "../../constants/AppTypes";
import HttpUtils from "../../utils/HttpUtils";
import { BaseCommonApiUseCaseDeps } from "./CommonApiUseCase";

export const getInventoryLogUseCase = async (
  deps: BaseCommonApiUseCaseDeps & {
    request: FilterInventoryLogRequest;
  },
): Promise<PageResponse<InventoryLogModel[]>> => {
  const { setLoading, showError, request } = deps;
  try {
    setLoading?.(true);
    let dataMapper: PageResponse<InventoryLogModel[]> = {
      data: [],
      total: 0,
    };
    const res = await InventoryLogService.getListInventoryLog(request);
    HttpUtils.handleResponse(res, {
      onDefaultError() {
        showError?.(res.message);
      },
      onSuccessWithData(res) {
        dataMapper = {
          data: res.data.data,
          total: res.data.total,
        };
      },
    });
    return dataMapper;
  } finally {
    setLoading?.(false);
  }
};

export const createInventoryLogUseCase = async (
  deps: BaseCommonApiUseCaseDeps & {
    request: CreateInventoryLogRequest;
  },
): Promise<InventoryLogModel | undefined> => {
  const { request, setLoading, showError, showSuccess } = deps;
  try {
    setLoading?.(true);
    let dataMapper: InventoryLogModel | undefined = undefined;
    const res = await InventoryLogService.createImportInventoryLog(request);

    HttpUtils.handleResponse(res, {
      onDefaultError() {
        showError?.(res.message);
      },
      onSuccessWithData(res) {
        showSuccess?.();
        dataMapper = res.data;
      },
    });
    return dataMapper;
  } finally {
    setLoading?.(false);
  }
};

export const deleteInventoryLogUseCase = async (
  deps: BaseCommonApiUseCaseDeps & { id: number },
): Promise<boolean> => {
  const { id, setLoading, showError, showSuccess } = deps;
  try {
    setLoading?.(true);
    let dataMapper = false;
    const res = await InventoryLogService.deleteInventoryLog(id);

    HttpUtils.handleResponse(res, {
      onDefaultError() {
        showError?.(res.message);
      },
      onSuccess() {
        showSuccess?.();
        dataMapper = true;
      },
    });
    return dataMapper;
  } finally {
    setLoading?.(false);
  }
};
